const mike = {
    image: 'https://i.imgur.com/ehF2OZp.jpeg',
    bio: {
        p1: `Mike White was born and raised in Hitchin, Hertfordshire, England in 1975 and moved to Las Vegas, in September 1989, where he developed his unequivocal affinity for music. Next, in the pursuit of new artistic adventures, he moved to San Diego, California and has prospered in this lovely city ever since...`,
        p2: `Mike has had the pleasure to spin at the sexiest lounges and upscale nightclubs in Las Vegas, Los Angeles, New York, and San Diego.
        The many styles of music which Mike flawlessly mixes and matches consists of—but is not limited to—Down-Tempo, Afrobeats, Trip-Hop, Old-School Hip Hop, French Hip Hop, Punjabi Hiphop , Japanese Hiphop, Filipino Hiphop Arabic Hiphop, Latin Hip Hop, Jazz, Latin, Funk, Neosoul, Soul, Rock, Electro Swing, 60's, 70's, 80's, 90's-Current, Mash-Ups, Blues, Reggae, Ska, Reggaton, Middle-Eastern, Two-Step, Dubstep, Jungle, Drum & Bass, Trap, Electro, Nudisco, Deep; Tribal; Tropical; & Tech House... Mike's extensive musical library is only amplified by his innate ability to read the crowd like a well-versed novel.`,
        p3: `Mike has performed with DJ's: A.M., Grandmaster Flash, Mark Ronson, Samantha Ronson, Scooter & Lavelle, and Steve Aoki.`
    },
    contact: {
        phone: "(702) 526-3020",
        email: "Djmikewhite@gmail.com",
        facebook: "https://www.facebook.com/mike.white.7739814",
        instagram: "https://www.instagram.com/djmikewhite_/",
        twitter: "https://x.com/?lang=en%40Djmikewhite007",
        soundcloud: "https://soundcloud.com/user-554826787",
    },
    modeling: {
        images: ['https://i.imgur.com/nbmIGqL.jpeg','https://i.imgur.com/UcYJwWD.jpeg', 'https://i.imgur.com/dZ3cdGx.jpeg', 'https://i.imgur.com/pP4QXY2.jpeg', 'https://i.imgur.com/i4bLatn.jpeg', 'https://i.imgur.com/NPhe42Z.jpeg', 'https://i.imgur.com/12qlNBY.jpeg', 'https://i.imgur.com/GQaNF6t.jpeg', "https://i.imgur.com/aRND8iZ.jpeg",'https://i.imgur.com/AqTl3Ci.jpeg', 'https://i.imgur.com/56OFZx4.png', 'https://i.imgur.com/WAey4uy.jpeg', 'https://i.imgur.com/11Y4hMA.jpeg', 'https://i.imgur.com/UihaBsk.jpeg', 'https://i.imgur.com/GXSZ6yZ.jpeg', 'https://i.imgur.com/bmcPt0n.jpeg', 'https://i.imgur.com/iuh1rBE.jpeg', 'https://i.imgur.com/f0YOzm3.jpeg', "https://i.imgur.com/7moWpBJ.jpeg", 'https://i.imgur.com/zVS1Ksn.jpeg', 'https://i.imgur.com/MIbS37C.jpeg'], 
        publications: {
            image: 'https://i.imgur.com/P3qthrn.jpeg',
            name: "Publications: ",
            list: [
                "RNT Architects Magazine (for SDGE) - March 2017",
                "Las Vegas Weekly Vol 10, Issue 20 'These Kicks Are Made For Dancing' Promotional photoshoot for RA & BABY'S nightclub & the ATTIC clothing stores",
                "The PAPER Las Vegas' It Magazine, Y2K Turn of The Century Issue",
                "Scope Magazine's Sixth Anniversary Party - May 1998",
                "GUESS? Jeans (Photoshoot for Retail Store Poster) - 1997",
                "SKI Show Daily - Vol 16 #3 - Mar 1996",
                "'Smoke & Cigar' Magazine - The Drink Nightclub Ad - Jan 1996",
                "Los Angeles & New York Times - Photoshoot for Venus in Furs - Sept 1995",
                "Transworld Snowboard Magazine (shot in clothes used in fashion show for S.I.A.) - 1995",
                "CALVIN KLEIN Billboard CK1 Advertisement - June 1994",
                "Exotic hair designs by DIVA Hair Salon - Details & Detour magazine - May 1994"
            ]
        },
        shows: {
            image:"https://i.imgur.com/gWLkqYS.jpeg",
            name: "Fashion Shows:",
            list: [
                "Scope Magazine's 6th Anniversary Party, @ Club Utopia - May 1998 (Assistant Choreographer, Model Assistant, & Runway Model)",
                "Buffalo Exchange Vintage Couture, @ Mariposa Cafe's Grand Opening - 1997",
                "Buffalo Exchange Vintage Couture @ Club Utopia - 1996",
                "S.I.A. Ski Convention, Janet Racy N.Y.C. (Runway Model) - 1995",
                "Buffalo Exchange Vintage Couture, @ Cafe' Espresso Roma - 1995"
            ]
        },
        promo: {
            image: 'https://i.imgur.com/V51gsQs.jpeg',
            name: "Promotional Materials:",
            list: [
                "Showroom Modeling for PRADA Spring/Summer/Fall 1999 Ready To Wear - Aug 1999",
                "(Exclusive Local MAGIC International Trade Show Model - DKNY) - Sept 1998",
                "MAGIC International Trade Show (Fall Collection Model - DKNY) - Feb 1998",
                "MAGIC International Trade Show (Exclusive Local Model - DKNY) - Aug 1997",
                "MAGIC International Trade Show (Model - Venus In Furs) - Aug 1995",
                "Action Sports International Trade Show (Model - TAG RAG) - Jan 1995"
            ]
        },
        host: {
            image: 'https://i.imgur.com/P5fi79X.jpeg',
            name: "Hosting:",
            list: ["Details Magazine Party (Host & Model) - Feb 1997",
                "SEMA-AAWI Automotive Convention (Spokesperson) - Nov 1996",
                "COMDEX - Aim Tech Corp (Host & Model) - Fall 1995",
                "Details Magazine Party (Host & Model) - Jan 1995"
            ]
        }
    },
    acting: {
        links: {
            video: {
                behiveVoice: 'BTkfCsPAoqo',
                prado: 'Ewtf-Di6xSY',
                yacht: 'CuTRUoXR8As',
                elsewhere: 'JgNKrt7vN5Y',
                rumor: 'KP024dgz-QE'
            },
        },
        commercial: {
            fordMach: {
                name: "EV Rideshare Leasing Program Commercial",
                role: "Skateboarder | Passenger | Rideshare Driver",
                year: "2022",
                company: "De Trois Production",
                location: "San Diego, CA"
            },
            champagneYacht: {
                name: "Champagne Yacht Commercial",
                role: "DJ",
                year: "2018",
                company: "Rowlbertos Media",
                location: "San Diego, CA"
            },
            elswhereYacht: {
                name: "Elsewhere Yacht Commercial",
                role: "DJ",
                year: "2018",
                company: "Rowlbertos Media",
                location: "San Diego, CA"
            },
            prado: {
                name: "Prado Restaurant Commercial",
                role: "Best Man",
                year: "2018",
                company: "Rowlbertos Media",
                location: "San Diego, CA"
            },
            rioHotel: {
                name: "Copacabana",
                role: "Extra",
                year: "1995",
                company: "Rio Hotel & Casino",
                location: "Las Vegas, NV"
            },
            mcDonalds: {
                name: "Magic Food with David Copperfield",
                role: "Extra",
                year: "1995",
                company: `McDonalds`,
                location: "Las Vegas, NV"
            },
            channelEight: {
                name: "Home Shopping on the Internet",
                role: "Delivery Elf",
                year: "1995",
                company: "Channel 8",
                location: "Las Vegas, NV"
            }
        },
        tv: {
            americanCasino: {
                name: "American Casino Reality TV",
                company: "Discovery Chanel",
                role: "Featured guest D.J. - 31 episodes",
                location: "Las Vegas, NV",
                year: "2004/2005"
            },
            cabConfessions: {
                name: "Taxi Cab Confessions",
                company: "HBO",
                role: "Guest",
                location: "Las Vegas, NV",
                year: "1998",
            },
            grind: {
                name: "The Grind",
                company: "MTV",
                role: "Host | Dancer",
                location: "Las Vegas, NV",
                year: "1997"
            },
            cyberChallenge: {
                name: "CYBERCHALLENGE",
                company: "",
                role: "Host | News Anchor | Writer | Floor Director",
                location: "Las Vegas, NV",
                year: "1997"
            },
            magician: {
                name: "World's Greatest Magician Show",
                company: "Lance Burton",
                role: "Illusion Assistant",
                location: "Las Vegas, NV",
                year: "1995"
            },
            beyondImagination: {
                name: "Beyond Imagination",
                company: "David Copperfield",
                role: "Illusion Assistant",
                location: "Las Vegas, NV",
                year: "1995"
            }
        },
        musicVideos: {
            angelComeDown: {
                name: "Angel Come Down",
                company: "Voice of Beehive",
                role: "Actor",
                location: "Las Vegas, NV",
                year: "1995"
            },
        },
        movies: {
            speedJunkie: {
                name: "Speedway Junkie",
                company: "Speedway Junkie Inc.",
                role: "V.I.P. host at club Utopia",
                location: "Las Vegas, NV",
                year: "1998"
            },
            vegasVacay: {
                name: `National Lampoon's "Vegas Vacation"`,
                company: "Warner Bros",
                role: "Extra",
                location: "Las Vegas, NV",
                year: "1996"
            },
            casino: {
                name: "Casino",
                company: "Universal Pictures",
                role: "Extra",
                location: "Las Vegas, NV",
                year: "1995"
            }
        },
        appearences: {
            luxListings: {
                name: "San Diego Luxury Listings",
                company: "CW TV Show with host Ty Hines",
                role: "DJ",
                location: "San Diego, CA",
                year: "2018"
            },
            kaplan: {
                name: "Kaplan at Night",
                company: "UT-TV San Diego",
                role: "DJ | Co Host",
                location: "San Diego, CA",
                year: "2013/2014"
            },
            frontPage: {
                name: `"FRONT PAGE" with Scott & Amber`,
                company: "UT-TV San Diego",
                role: "Featured regular D.J. spinning 3 hour performance from 6a-9a live",
                location: "San Diego, CA",
                year: "2013/2014"
            },
            kusiNews: {
                name: "Good Morning San Diego",
                company: "KUSI News",
                role: `Special guest appearance as competitor for Ra Sushi's "Sushi Showdown"`,
                location: "San Diego, CA",
                year: "2013"
            },
            foxNews: {
                name: "Morning Show on FOX",
                company: "FOX 5 San Diego ",
                role: "Performed as live D.J. with Violinist Yvonne Shay",
                location: "San Diego, CA",
                year: "2011"
            }
        }
    },
    dj: {
        links: {
            audio: {
                unwind: {
                    src: 'https://soundcloud.com/user-554826787/unwind',
                    image: 'https://i.imgur.com/WAey4uy.jpeg',
                    name: 'Unwind'
                },
                sexyTime: {
                    src: 'https://soundcloud.com/user-554826787/sexytime',
                    image: 'https://i.imgur.com/VMQqEA7.jpeg',
                    name: 'Sexy Time'
                },
                inspiredBy: {
                    src: 'https://soundcloud.com/user-554826787/an-album-inspired-by-kruder-dorfmeister-mixed-by-dj-mike-white',
                    image: 'https://i.imgur.com/fHMsQky.jpeg',
                    name: 'An inspired album...'
                }
            },
            video: {
                liveARoll: 'BKKLGFTLobs',
                laborDay: 'drABef-QGhg',
                SirensCrush: 'vz0OvRqfbro',
                carnitas: 'MNHSMyaNZ6Y',
                spiritsFest: '5ZcIKeqHBuo',
                elsewhere: 'JgNKrt7vN5Y',
                rumor: 'KP024dgz-QE',
                wind :'aYbvn2F1Xn8'
            }
        },
        djFor: {
            list: ["Andre Agassi Foundation",
                "Aston Martin",
                "Athena Health",
                "Augie Helicopters",
                "A/V Irvine",
                "Bentley",
                "Breitling",
                "Bugatti",
                "Cam Newton Foundation",
                "Chartis",
                "Christian Dior",
                "Curator San Diego",
                "Deluxe San Diego",
                "Dewitt",
                "Discover S.D.",
                "Donna Karan",
                "Ferrari & Maserati of San Diego",
                "Formula Pr",
                "Frasier Yachts",
                "HP",
                "Hasbro",
                "Harker Beechkraft Private Jet Co.",
                "I-Tan",
                "Jaguar",
                "Kimpton Hotels West Coast",
                "Lamborghini",
                "Lalique",
                "Lmk Events",
                "Mac Cosmetics",
                "Martin Katz Jewelry",
                "Morris Yachts",
                "Naval Special Warfare Foundation",
                "Playboy Golf",
                "Porsche",
                "Puma",
                "Puma Golf",
                "Qualcomm",
                "Rancho Santa Fe Magazine",
                "Rolls Royce",
                "San Diego Magazine",
                "San Diego Brain Tumor Foundation",
                "San Diego Spirits Festival",
                "The San Diego Chargers",
                "Sandow Events",
                "Sea Magines Submarines",
                "SolidWorks World 2012",
                "Showtech",
                "SYFY Channel",
                "Symbolic Motors",
                "Universal Cable Productions",
                "U-T San Diego & UT-TV",
                "Zenith Timepieces"],
            name: 'As a Featured D.J.'
        },
        openedFor: {
            list: ['Barenaked Ladies',
                'Biz Markie',
                'Black Eyed Peas',
                'Dave Matthews',
                'De La Soul',
                'Flogging Molly',
                'LL Cool J',
                'Sade',
                'Sean Paul',
                'Seal',
                'Thievery Corporation'],
            name: "As an Opening D.J."
        },
        appearences: {
            list: ["UT-TV San Diego: 'FRONT PAGE' - featured DJ spinning a lively 3-hour performance",
                "UT-TV San Diego: 'Kaplan at Night' - DJ/Co-Host",
                "KUSI News 'Good Morning San Diego' - special guest appearance",
                "FOX 5 San Diego Morning Show - live set accompanied by Violinist Yvonne Shay, of the San Diego Symphony Orchestra",
                "Discovery Channel's documentary series 'American Casino' - DJ sets for big productions at Green Valley Ranch, Las Vegas",
                "DJ at Erykah Badu's private CD release party at Noir Bar, Las Vegas",
                "DJ for private SNL book signing party for Mary Ellen Matthews",
                "House of Blues 20th Anniversary V.I.P. Party - personal DJ for Flogging Molly's V.I.P. party",
                "BUDWEISER commercial - 1997"],
            name: "As a Guest D.J."
        },
        prevExperience: {
            sanDiego: {
                locations: [
                    "57 Degrees Wine Parlor",
                    "207 @ HardRock Hotel",
                    "AIR CONDITIONED Lounge",
                    "AIRR Supperclub (Resident)",
                    "Altitude Sky Lounge",
                    "American Legion Post 365",
                    "Andaz Hotel",
                    "Backyard Kitchen & Tap (Resident)",
                    "Bardello (Resident)",
                    "Bassmnt Nightclub",
                    "Belly Up tavern- Solana Beach",
                    "Bíjou French Bistro",
                    "Birch Aquarium at Scripps Institute of Oceanography",
                    "Block No.16",
                    "Bloomingdale's - Fashion Valley",
                    "Carnitas Snack Shack (Resident)",
                    "Catarmaran Resort Hotel & Spa",
                    "Cat Eye Club",
                    "Champagne Yacht",
                    "Chillers Showroom - Pacific Beach",
                    "Club M at The Grand Del Mar (Resident)",
                    "Culy Warehouse",
                    "El Dorado Cocktail Lounge",
                    "Elsewhere Yacht",
                    "Estancia La Jolla",
                    "Extraordinary Desserts - Little Italy",
                    "Firehouse - Pacific Beach",
                    "Flavor Del Mar (Resident)",
                    "Float @ Hard Rock Hotel",
                    "Fox 5",
                    "G Star Raw",
                    "Gaslamp District - Downtown San Diego",
                    "Gaslamp Tavern",
                    "Genesis Kitchen + Drinks",
                    "GoodBar",
                    "Henry's Pub",
                    "Herringbone La Jolla",
                    "HIATUS at La Jolla Hotel",
                    "Hornblower Cruise ship",
                    "Hotel Indigo",
                    "House of Blues (Resident)",
                    "Hotel Lafayette",
                    "Ivy Nightclub",
                    "Kamikaze 7 A Sushi Joint (Resident)",
                    "KNIX La Jolla",
                    "La Jolla Country Club",
                    "Latitude 33 Brewing",
                    "Little Italy Food Hall",
                    "Lomas Santa Fe Country Club",
                    "LOUNGEsix (Resident)",
                    "Magnolia Tap & Kitchen",
                    "Masala",
                    "Minus 1 (Resident)",
                    "Morgan Run Club & Resort",
                    "Moxy San Diego (Resident)",
                    "Museum of Contemporary Art La Jolla",
                    "New San Diego Central Library",
                    "NTC Park Liberty Station",
                    "Omnia San Diego",
                    "Pali Wine Co. Little Italy",
                    "Paradise Point Resort & Spa",
                    "Parq Nightclub & Restaurant",
                    "PINK by Victoria Secret (Horton Plaza, Fashion Valley, & UTC)",
                    "Port Pavilion on Broadway Pier",
                    "Posh Lounge",
                    "Puma Retail Store",
                    "Puma Golf",
                    "Quality Social (Resident)",
                    "RA Sushi (Resident)",
                    "Rancho Valencia Resort & Spa",
                    "Red Circle",
                    "Revel Revel",
                    "Salomar Hotel",
                    "Sandbar - Mission Beach",
                    "SandBox",
                    "San Diego Brian Tumor Foundation",
                    "San Diego Convention Center",
                    "San Diego Rowing Club",
                    "San Diego Spirits Festival",
                    "Searsucker (Resident)",
                    "Sew Loka",
                    "Sheraton Harbor Island",
                    "SILO in Makers Quarter",
                    "Siren at Se' (Resident)",
                    "Sora",
                    "Social Tap—Downtown & SDSU (Resident)",
                    "Stage",
                    "STK San Diego (Resident)",
                    "Suite & Tender (Resident)",
                    "Sway (Resident)",
                    "Terranea Resort - Rancho Palos Verdes",
                    "The Blind Burro (Resident)",
                    "The Champagne Yacht",
                    "The Cordova Bar",
                    "The Glass Door at Porto Vista Hotel",
                    "The Local Eatery & Drinking Hole",
                    "The Loma Club, Liberty Station",
                    "The Merk Bistro",
                    "The New Children's Museum",
                    "The Observatory North Park",
                    "The University Club Atop Symphony Towers",
                    "TOAST Enoteca & Cucina",
                    "Tom Ham's Lighthouse",
                    "U-31",
                    "Upper East Bar & Hotel Salomar",
                    "USS Midway",
                    "Victoria's Secret (Horton Plaza, Fashion Valley, & UTC)",
                    "Vin De Syrah",
                    "Voyeur",
                    "W Hotel",
                    "Walk The Block SD in Barrio Logan"],
                image: "https://i.imgur.com/2O7KGP6.jpeg",
                city: "San Diego, California"
            },
            palmSprings: {
                locations: ["Starlight Lounge at Riviera Resort Spa"],
                image: "https://i.imgur.com/soZ7oyi.jpeg",
                city: "Palm Springs, California"
            },
            Vegas: {
                locations: ["Beluga Bar (Resident)",
                    "C2K (Resident)",
                    "Club 1030",
                    "Club Seven",
                    "Curve (Resident)",
                    "Double Helix (Resident)",
                    "The Drink (Resident)",
                    "Downtown Cocktail Room (Resident)",
                    "Drais (Resident)",
                    "Foundation Room (Resident)",
                    "Glow",
                    "Green Valley Ranch Hotel & Casino",
                    "Ghostbar",
                    "Halfshell (Resident)",
                    "Hookah Lounge (Resident)",
                    "Hush",
                    "House of Blues (Resident)",
                    "Ice House",
                    "Itsy Bitsy Ramen & Whiskey",
                    "Josef's",
                    "Kit Kat Klub",
                    "Lure (Resident)",
                    "Manhattan Lounge (Resident)",
                    "Mixx",
                    "Nickarinos (Resident)",
                    "Nove Italiano",
                    "Noir Bar (Resident)",
                    "Puma Store",
                    "Ra",
                    "Red Dragon (Resident)",
                    "Risqué (Resident)",
                    "Rumor",
                    "Sevilla (Resident)",
                    "SRO (Resident)",
                    "TAO",
                    "The Lady Silvia",
                    "The Red Room",
                    "Tsunami",
                    "Turnberry",
                    "Utopia (Resident)",
                    "V Bar (Resident)",
                    "Velvet Lounge (Resident)",
                    "Venus (Resident)",
                    "Vox",
                    "Whiskey Sky (Resident)",
                    "The Historical Glass Pool Inn"],
                image: "https://i.imgur.com/WYPhHOV.jpeg",
                city: "Las Vegas, Nevada"
            },
            la: {
                locations: ["Whiskey Blue"],
                image: "https://i.imgur.com/uLfW5z0.png",
                city: "Los Angeles, California"
            },
            ny: {
                locations: ["Whiskey Blue"],
                image: "https://i.imgur.com/3JBkh6t.jpeg",
                city: "New York, New York"
            },
            Charlotte: {
                locations: ["Vivace"],
                image: "https://i.imgur.com/Oqdr1Ty.jpeg",
                city: "Charlotte, North Carolina"
            },
        },
        residencies: {
            stk: {
                name: "STK San Diego",
                image: "https://i.imgur.com/AXNvfBK.jpeg",
                src: "https://stksteakhouse.com/"
            },
            houseOfBlues: {
                name: "House of Blues",
                image: "https://i.imgur.com/qW7tDfI.jpeg",
                src: "https://www.houseofblues.com/sandiego?y_source=1_MTU2MzYxNjItNzE1LWxvY2F0aW9uLndlYnNpdGU%3D"
            },
            carnitas: {
                name: 'Carnitas Snack Shack',
                image: "https://i.imgur.com/z9oZM4D.jpeg",
                src: "https://carnitassnackshack.com/"
            }
        }
    },
    skills: {
        skateboarding: {
            name: 'Skateboarding',
            images: ["https://i.imgur.com/hl6g8Jc.jpeg", "https://i.imgur.com/K009TOz.jpeg", "https://i.imgur.com/u1aa1JS.jpeg"],
            videos: {
                justPlaying: 'NNCgEeyO62A',
                coronadoSkate: "lBNiJLBJy-k",
                justOut: "I385PP2R9OE",
                chillaxin: "cTrkEmeIcTY",
                justHanging: "6y0zeK5aELU",
                shenanigans: "gNEWVJTq6Fw"
            }
        }
    }
};

export default mike;